{
  "nm": "Main Scene",
  "ddd": 0,
  "h": 500,
  "w": 500,
  "meta": { "g": "@lottiefiles/creator 1.45.0" },
  "layers": [
    {
      "ty": 4,
      "nm": "favicon",
      "sr": 1,
      "st": 0,
      "op": 51,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [15.500012397766113, 16.025550603866577] },
        "s": { "a": 0, "k": [1340.8793, 1340.8793] },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [249.5000123977661, 250.02555060386658] },
        "r": { "a": 0, "k": 0 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 90 }
      },
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "nm": "Group 1",
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "nm": "Path 1",
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [1.0117299999999982, -1.0466499999999996],
                    [0, 0],
                    [0.09645999999999866, -0.1504000000000012],
                    [-0.38668000000000013, -0.6032999999999991],
                    [-0.2910800000000009, -0.3011000000000017],
                    [0, 0],
                    [-0.3092000000000006, -1.1025000000000027],
                    [0.26069999999999993, -0.9296000000000006],
                    [0.7846399999999996, -0.8117000000000019],
                    [0, 0],
                    [0.09645999999999866, -0.15050000000000097],
                    [-0.38668000000000013, -0.6033000000000008],
                    [-0.2910800000000009, -0.3011000000000017],
                    [0, 0],
                    [-0.6198999999999995, -0.0630999999999986],
                    [-0.11340000000000039, 0.011600000000001387],
                    [-1.0115999999999996, 1.0466000000000015],
                    [0, 0],
                    [-0.0965000000000007, 0.15039999999999765],
                    [0.3866999999999994, 0.6032999999999973],
                    [0.29109999999999836, 0.30109999999999815],
                    [0, 0],
                    [0.3092000000000006, 1.1024999999999991],
                    [-0.26069999999999993, 0.9295999999999971],
                    [-0.7845999999999993, 0.8117000000000001],
                    [0, 0],
                    [-0.0965000000000007, 0.15050000000000097],
                    [0.3866999999999994, 0.6032999999999991],
                    [0.29109999999999836, 0.3010999999999999],
                    [0, 0],
                    [0.6198999999999995, 0.06315999999999988],
                    [0.11350000000000016, -0.011570000000000746]
                  ],
                  "o": [
                    [0, 0],
                    [-0.2910800000000009, 0.3010999999999999],
                    [-0.38668000000000013, 0.6032999999999991],
                    [0.09645999999999866, 0.15050000000000097],
                    [0, 0],
                    [0.7846399999999996, 0.8117000000000001],
                    [0.26069999999999993, 0.9295999999999971],
                    [-0.3092000000000006, 1.1024999999999991],
                    [0, 0],
                    [-0.2910800000000009, 0.30109999999999815],
                    [-0.38668000000000013, 0.6032999999999973],
                    [0.09645999999999866, 0.15039999999999765],
                    [0, 0],
                    [1.0117399999999996, 1.0466000000000015],
                    [0.11350000000000016, 0.011600000000001387],
                    [0.6198999999999995, -0.0630999999999986],
                    [0, 0],
                    [0.29109999999999836, -0.3011000000000017],
                    [0.3866999999999994, -0.6033000000000008],
                    [-0.0965000000000007, -0.15050000000000097],
                    [0, 0],
                    [-0.7845999999999993, -0.8117000000000019],
                    [-0.26069999999999993, -0.9296000000000006],
                    [0.3092000000000006, -1.1025000000000027],
                    [0, 0],
                    [0.29109999999999836, -0.3011000000000017],
                    [0.3866999999999994, -0.6032999999999991],
                    [-0.0965000000000007, -0.1504000000000012],
                    [0, 0],
                    [-1.0115999999999996, -1.0466499999999996],
                    [-0.11340000000000039, -0.011570000000000746],
                    [-0.6198999999999995, 0.06315999999999988]
                  ],
                  "v": [
                    [9.586970000000003, 10.0753],
                    [8.82309, 10.8656],
                    [8.29001, 11.4677],
                    [8.29001, 13.4584],
                    [8.82309, 14.060600000000003],
                    [9.610960000000002, 14.8757],
                    [11.2783, 17.793599999999998],
                    [11.2783, 20.639900000000004],
                    [9.610960000000002, 23.5578],
                    [8.82309, 24.3729],
                    [8.29001, 24.975100000000005],
                    [8.29001, 26.9658],
                    [8.82309, 27.5679],
                    [9.58696, 28.358200000000004],
                    [11.7244, 29.991299999999995],
                    [12.0656, 29.991299999999995],
                    [14.203, 28.358200000000004],
                    [14.966900000000003, 27.5679],
                    [15.5, 26.9658],
                    [15.5, 24.975100000000005],
                    [14.966900000000003, 24.3729],
                    [14.179100000000002, 23.5578],
                    [12.5117, 20.639900000000004],
                    [12.5117, 17.793599999999998],
                    [14.179100000000002, 14.8757],
                    [14.966900000000003, 14.060600000000003],
                    [15.5, 13.4584],
                    [15.5, 11.4677],
                    [14.966900000000003, 10.8656],
                    [14.203, 10.0753],
                    [12.0656, 8.44217],
                    [11.7244, 8.44217]
                  ]
                }
              }
            },
            {
              "ty": "gf",
              "bm": 0,
              "hd": false,
              "nm": "Fill",
              "e": { "a": 0, "k": [17.9842, 34.0731] },
              "g": { "p": 2, "k": { "a": 0, "k": [0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 1] } },
              "t": 1,
              "a": { "a": 0, "k": 0 },
              "h": { "a": 0, "k": 0 },
              "s": { "a": 0, "k": [7.93755, 5.0309] },
              "r": 1,
              "o": { "a": 0, "k": 40 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [11.895012378692629, 19.24229907989502] },
              "s": { "a": 0, "k": [100, 100] },
              "sk": { "a": 0, "k": 0 },
              "p": {
                "a": 1,
                "k": [
                  { "o": { "x": 0, "y": 0 }, "i": { "x": 0.36, "y": 1 }, "s": [11.895, 19.2423], "t": 0 },
                  { "o": { "x": 0.22, "y": 0.61 }, "i": { "x": 0.36, "y": 1 }, "s": [11.895, 15.2423], "t": 8 },
                  { "o": { "x": 0.22, "y": 0.61 }, "i": { "x": 0.36, "y": 1 }, "s": [11.895, 23.2423], "t": 24 },
                  { "o": { "x": 0.22, "y": 0.61 }, "i": { "x": 0.36, "y": 1 }, "s": [11.895, 17.2423], "t": 36 },
                  { "o": { "x": 0.22, "y": 0.61 }, "i": { "x": 0.36, "y": 1 }, "s": [11.895, 20.2423], "t": 40 },
                  { "s": [11.895, 19.2423], "t": 45 }
                ]
              },
              "r": { "a": 0, "k": 0 },
              "sa": { "a": 0, "k": 0 },
              "o": { "a": 0, "k": 100 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "nm": "Group 2",
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "nm": "Path 2",
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": false,
                  "i": [
                    [1.0117299999999982, -1.0466499999999996],
                    [0, 0],
                    [0.09645999999999866, -0.1504000000000012],
                    [-0.38668000000000013, -0.6032999999999991],
                    [-0.2910800000000009, -0.3011000000000017],
                    [0, 0],
                    [-0.3092000000000006, -1.1025000000000027],
                    [0.26069999999999993, -0.9296000000000006],
                    [0.7846399999999996, -0.8117000000000019],
                    [0, 0],
                    [0.09645999999999866, -0.15050000000000097],
                    [-0.38668000000000013, -0.6033000000000008],
                    [-0.2910800000000009, -0.3011000000000017],
                    [0, 0],
                    [-0.6198999999999995, -0.0630999999999986],
                    [-0.11340000000000039, 0.011600000000001387],
                    [-1.0115999999999996, 1.0466000000000015],
                    [0, 0],
                    [-0.0965000000000007, 0.15039999999999765],
                    [0.3866999999999994, 0.6032999999999973],
                    [0.29109999999999836, 0.30109999999999815],
                    [0, 0],
                    [0.3092000000000006, 1.1024999999999991],
                    [-0.26069999999999993, 0.9295999999999971],
                    [-0.7845999999999993, 0.8117000000000001],
                    [0, 0],
                    [-0.0965000000000007, 0.15050000000000097],
                    [0.3866999999999994, 0.6032999999999991],
                    [0.29109999999999836, 0.3010999999999999],
                    [0, 0],
                    [0.6198999999999995, 0.06315999999999988],
                    [0.11350000000000016, -0.011570000000000746]
                  ],
                  "o": [
                    [0, 0],
                    [-0.2910800000000009, 0.3010999999999999],
                    [-0.38668000000000013, 0.6032999999999991],
                    [0.09645999999999866, 0.15050000000000097],
                    [0, 0],
                    [0.7846399999999996, 0.8117000000000001],
                    [0.26069999999999993, 0.9295999999999971],
                    [-0.3092000000000006, 1.1024999999999991],
                    [0, 0],
                    [-0.2910800000000009, 0.30109999999999815],
                    [-0.38668000000000013, 0.6032999999999973],
                    [0.09645999999999866, 0.15039999999999765],
                    [0, 0],
                    [1.0117399999999996, 1.0466000000000015],
                    [0.11350000000000016, 0.011600000000001387],
                    [0.6198999999999995, -0.0630999999999986],
                    [0, 0],
                    [0.29109999999999836, -0.3011000000000017],
                    [0.3866999999999994, -0.6033000000000008],
                    [-0.0965000000000007, -0.15050000000000097],
                    [0, 0],
                    [-0.7845999999999993, -0.8117000000000019],
                    [-0.26069999999999993, -0.9296000000000006],
                    [0.3092000000000006, -1.1025000000000027],
                    [0, 0],
                    [0.29109999999999836, -0.3011000000000017],
                    [0.3866999999999994, -0.6032999999999991],
                    [-0.0965000000000007, -0.1504000000000012],
                    [0, 0],
                    [-1.0115999999999996, -1.0466499999999996],
                    [-0.11340000000000039, -0.011570000000000746],
                    [-0.6198999999999995, 0.06315999999999988]
                  ],
                  "v": [
                    [9.586970000000003, 10.0753],
                    [8.82309, 10.8656],
                    [8.29001, 11.4677],
                    [8.29001, 13.4584],
                    [8.82309, 14.060600000000003],
                    [9.610960000000002, 14.8757],
                    [11.2783, 17.793599999999998],
                    [11.2783, 20.639900000000004],
                    [9.610960000000002, 23.5578],
                    [8.82309, 24.3729],
                    [8.29001, 24.975100000000005],
                    [8.29001, 26.9658],
                    [8.82309, 27.5679],
                    [9.58696, 28.358200000000004],
                    [11.7244, 29.991299999999995],
                    [12.0656, 29.991299999999995],
                    [14.203, 28.358200000000004],
                    [14.966900000000003, 27.5679],
                    [15.5, 26.9658],
                    [15.5, 24.975100000000005],
                    [14.966900000000003, 24.3729],
                    [14.179100000000002, 23.5578],
                    [12.5117, 20.639900000000004],
                    [12.5117, 17.793599999999998],
                    [14.179100000000002, 14.8757],
                    [14.966900000000003, 14.060600000000003],
                    [15.5, 13.4584],
                    [15.5, 11.4677],
                    [14.966900000000003, 10.8656],
                    [14.203, 10.0753],
                    [12.0656, 8.44217],
                    [11.7244, 8.44217]
                  ]
                }
              }
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "nm": "Fill",
              "c": { "a": 0, "k": [0.2431, 0.7647, 0.8] },
              "r": 1,
              "o": { "a": 0, "k": 100 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [11.895012378692629, 19.24229907989502] },
              "s": { "a": 0, "k": [100, 100] },
              "sk": { "a": 0, "k": 0 },
              "p": {
                "a": 1,
                "k": [
                  { "o": { "x": 0, "y": 0 }, "i": { "x": 0.36, "y": 1 }, "s": [11.895, 19.2423], "t": 0 },
                  { "o": { "x": 0.22, "y": 0.61 }, "i": { "x": 0.36, "y": 1 }, "s": [11.895, 15.2423], "t": 8 },
                  { "o": { "x": 0.22, "y": 0.61 }, "i": { "x": 0.36, "y": 1 }, "s": [11.895, 23.2423], "t": 24 },
                  { "o": { "x": 0.22, "y": 0.61 }, "i": { "x": 0.36, "y": 1 }, "s": [11.895, 17.2423], "t": 36 },
                  { "o": { "x": 0.22, "y": 0.61 }, "i": { "x": 0.36, "y": 1 }, "s": [11.895, 20.2423], "t": 40 },
                  { "s": [11.895, 19.2423], "t": 45 }
                ]
              },
              "r": { "a": 0, "k": 0 },
              "sa": { "a": 0, "k": 0 },
              "o": { "a": 0, "k": 100 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "nm": "Group 3",
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "nm": "Path 3",
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0.0965000000000007, -0.15047999999999995],
                    [-0.3866999999999994, -0.6032600000000006],
                    [-0.29110000000000014, -0.3011400000000002],
                    [0, 0],
                    [-0.3092000000000006, -1.1024999999999991],
                    [0.26069999999999993, -0.9296000000000006],
                    [0.7845999999999975, -0.8117000000000019],
                    [0, 0],
                    [0.0965000000000007, -0.1504999999999974],
                    [-0.3866999999999994, -0.6033000000000008],
                    [-0.29110000000000014, -0.3011999999999979],
                    [0, 0],
                    [-0.6199000000000012, -0.0630999999999986],
                    [-0.11350000000000193, 0.011600000000001387],
                    [-1.0117000000000012, 1.0466999999999977],
                    [0, 0],
                    [-0.09650000000000247, 0.1504000000000012],
                    [0.3866999999999976, 0.6033000000000008],
                    [0.29110000000000014, 0.30120000000000147],
                    [0, 0],
                    [0.3092000000000006, 1.1024999999999991],
                    [-0.26069999999999993, 0.9296000000000006],
                    [-0.7846000000000011, 0.8117099999999997],
                    [0, 0],
                    [-0.09650000000000247, 0.15047999999999995],
                    [0.3866999999999976, 0.6032599999999997],
                    [0.29110000000000014, 0.3011400000000002],
                    [0, 0],
                    [0.6198999999999977, 0.06315999999999988],
                    [0.11339999999999861, -0.011560000000000015],
                    [1.0115999999999978, -1.04664]
                  ],
                  "o": [
                    [0, 0],
                    [-0.29110000000000014, 0.3011400000000002],
                    [-0.3866999999999994, 0.6032599999999997],
                    [0.0965000000000007, 0.15047999999999995],
                    [0, 0],
                    [0.7845999999999975, 0.8117099999999997],
                    [0.26069999999999993, 0.9296000000000006],
                    [-0.3092000000000006, 1.1024999999999991],
                    [0, 0],
                    [-0.29110000000000014, 0.30120000000000147],
                    [-0.3866999999999994, 0.6033000000000008],
                    [0.0965000000000007, 0.1504000000000012],
                    [0, 0],
                    [1.0115999999999978, 1.0466999999999977],
                    [0.11339999999999861, 0.011600000000001387],
                    [0.6198999999999977, -0.0630999999999986],
                    [0, 0],
                    [0.29110000000000014, -0.3011999999999979],
                    [0.3866999999999976, -0.6033000000000008],
                    [-0.09650000000000247, -0.1504999999999974],
                    [0, 0],
                    [-0.7846000000000011, -0.8117000000000019],
                    [-0.26069999999999993, -0.9296000000000006],
                    [0.3092000000000006, -1.1024999999999991],
                    [0, 0],
                    [0.29110000000000014, -0.3011400000000002],
                    [0.3866999999999976, -0.6032600000000006],
                    [-0.09650000000000247, -0.15047999999999995],
                    [0, 0],
                    [-1.0116000000000014, -1.04665],
                    [-0.11350000000000193, -0.011560000000000015],
                    [-0.6199000000000012, 0.06315999999999988],
                    [0, 0]
                  ],
                  "v": [
                    [16.797, 3.64179],
                    [16.0331, 4.43206],
                    [15.5, 5.03425],
                    [15.5, 7.02491],
                    [16.0331, 7.6271],
                    [16.8209, 8.44219],
                    [18.4883, 11.3601],
                    [18.4883, 14.2064],
                    [16.8209, 17.1243],
                    [16.0331, 17.9394],
                    [15.5, 18.5416],
                    [15.5, 20.5323],
                    [16.0331, 21.1345],
                    [16.797, 21.9247],
                    [18.9344, 23.5578],
                    [19.2756, 23.5578],
                    [21.413, 21.9247],
                    [22.1769, 21.1345],
                    [22.71, 20.5323],
                    [22.71, 18.5416],
                    [22.1769, 17.9394],
                    [21.389, 17.1243],
                    [19.7217, 14.2064],
                    [19.7217, 11.3601],
                    [21.389, 8.44219],
                    [22.1769, 7.6271],
                    [22.71, 7.02491],
                    [22.71, 5.03425],
                    [22.1769, 4.43206],
                    [21.413, 3.6418],
                    [19.2756, 2.00867],
                    [18.9344, 2.00867],
                    [16.797, 3.64179]
                  ]
                }
              }
            },
            {
              "ty": "gf",
              "bm": 0,
              "hd": false,
              "nm": "Fill",
              "e": { "a": 0, "k": [17.9842, 34.0731] },
              "g": { "p": 2, "k": { "a": 0, "k": [0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 1] } },
              "t": 1,
              "a": { "a": 0, "k": 0 },
              "h": { "a": 0, "k": 0 },
              "s": { "a": 0, "k": [7.93755, 5.0309] },
              "r": 1,
              "o": { "a": 0, "k": 40 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [19.105000019073486, 12.808800458908081] },
              "s": { "a": 0, "k": [100, 100] },
              "sk": { "a": 0, "k": 0 },
              "p": {
                "a": 1,
                "k": [
                  { "o": { "x": 0.55, "y": 0.06 }, "i": { "x": 0.36, "y": 1 }, "s": [19.105, 12.8088], "t": 0 },
                  { "o": { "x": 0.65, "y": 0 }, "i": { "x": 0.36, "y": 1 }, "s": [19.105, 8.8088], "t": 8 },
                  { "o": { "x": 0, "y": 0 }, "i": { "x": 0.36, "y": 1 }, "s": [19.105, 8.924250803715154], "t": 10 },
                  { "o": { "x": 0.65, "y": 0 }, "i": { "x": 0.36, "y": 1 }, "s": [19.105, 16.8088], "t": 24 },
                  { "o": { "x": 0.65, "y": 0 }, "i": { "x": 0.36, "y": 1 }, "s": [19.105, 10.8088], "t": 36 },
                  { "o": { "x": 0.65, "y": 0 }, "i": { "x": 0.36, "y": 1 }, "s": [19.105, 13.8088], "t": 40 },
                  { "s": [19.105, 12.8088], "t": 46 }
                ]
              },
              "r": { "a": 0, "k": 0 },
              "sa": { "a": 0, "k": 0 },
              "o": { "a": 0, "k": 100 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "nm": "Group 4",
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "nm": "Path 4",
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0.0965000000000007, -0.15047999999999995],
                    [-0.3866999999999994, -0.6032600000000006],
                    [-0.29110000000000014, -0.3011400000000002],
                    [0, 0],
                    [-0.3092000000000006, -1.1024999999999991],
                    [0.26069999999999993, -0.9296000000000006],
                    [0.7845999999999975, -0.8117000000000019],
                    [0, 0],
                    [0.0965000000000007, -0.1504999999999974],
                    [-0.3866999999999994, -0.6033000000000008],
                    [-0.29110000000000014, -0.3011999999999979],
                    [0, 0],
                    [-0.6199000000000012, -0.0630999999999986],
                    [-0.11350000000000193, 0.011600000000001387],
                    [-1.0117000000000012, 1.0466999999999977],
                    [0, 0],
                    [-0.09650000000000247, 0.1504000000000012],
                    [0.3866999999999976, 0.6033000000000008],
                    [0.29110000000000014, 0.30120000000000147],
                    [0, 0],
                    [0.3092000000000006, 1.1024999999999991],
                    [-0.26069999999999993, 0.9296000000000006],
                    [-0.7846000000000011, 0.8117099999999997],
                    [0, 0],
                    [-0.09650000000000247, 0.15047999999999995],
                    [0.3866999999999976, 0.6032599999999997],
                    [0.29110000000000014, 0.3011400000000002],
                    [0, 0],
                    [0.6198999999999977, 0.06315999999999988],
                    [0.11339999999999861, -0.011560000000000015],
                    [1.0115999999999978, -1.04664]
                  ],
                  "o": [
                    [0, 0],
                    [-0.29110000000000014, 0.3011400000000002],
                    [-0.3866999999999994, 0.6032599999999997],
                    [0.0965000000000007, 0.15047999999999995],
                    [0, 0],
                    [0.7845999999999975, 0.8117099999999997],
                    [0.26069999999999993, 0.9296000000000006],
                    [-0.3092000000000006, 1.1024999999999991],
                    [0, 0],
                    [-0.29110000000000014, 0.30120000000000147],
                    [-0.3866999999999994, 0.6033000000000008],
                    [0.0965000000000007, 0.1504000000000012],
                    [0, 0],
                    [1.0115999999999978, 1.0466999999999977],
                    [0.11339999999999861, 0.011600000000001387],
                    [0.6198999999999977, -0.0630999999999986],
                    [0, 0],
                    [0.29110000000000014, -0.3011999999999979],
                    [0.3866999999999976, -0.6033000000000008],
                    [-0.09650000000000247, -0.1504999999999974],
                    [0, 0],
                    [-0.7846000000000011, -0.8117000000000019],
                    [-0.26069999999999993, -0.9296000000000006],
                    [0.3092000000000006, -1.1024999999999991],
                    [0, 0],
                    [0.29110000000000014, -0.3011400000000002],
                    [0.3866999999999976, -0.6032600000000006],
                    [-0.09650000000000247, -0.15047999999999995],
                    [0, 0],
                    [-1.0116000000000014, -1.04665],
                    [-0.11350000000000193, -0.011560000000000015],
                    [-0.6199000000000012, 0.06315999999999988],
                    [0, 0]
                  ],
                  "v": [
                    [16.797, 3.64179],
                    [16.0331, 4.43206],
                    [15.5, 5.03425],
                    [15.5, 7.02491],
                    [16.0331, 7.6271],
                    [16.8209, 8.44219],
                    [18.4883, 11.3601],
                    [18.4883, 14.2064],
                    [16.8209, 17.1243],
                    [16.0331, 17.9394],
                    [15.5, 18.5416],
                    [15.5, 20.5323],
                    [16.0331, 21.1345],
                    [16.797, 21.9247],
                    [18.9344, 23.5578],
                    [19.2756, 23.5578],
                    [21.413, 21.9247],
                    [22.1769, 21.1345],
                    [22.71, 20.5323],
                    [22.71, 18.5416],
                    [22.1769, 17.9394],
                    [21.389, 17.1243],
                    [19.7217, 14.2064],
                    [19.7217, 11.3601],
                    [21.389, 8.44219],
                    [22.1769, 7.6271],
                    [22.71, 7.02491],
                    [22.71, 5.03425],
                    [22.1769, 4.43206],
                    [21.413, 3.6418],
                    [19.2756, 2.00867],
                    [18.9344, 2.00867],
                    [16.797, 3.64179]
                  ]
                }
              }
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "nm": "Fill",
              "c": { "a": 0, "k": [0.2431, 0.7647, 0.8] },
              "r": 1,
              "o": { "a": 0, "k": 100 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [19.105000019073486, 12.808800458908081] },
              "s": { "a": 0, "k": [100, 100] },
              "sk": { "a": 0, "k": 0 },
              "p": {
                "a": 1,
                "k": [
                  { "o": { "x": 0.55, "y": 0.06 }, "i": { "x": 0.36, "y": 1 }, "s": [19.105, 12.8088], "t": 0 },
                  { "o": { "x": 0.65, "y": 0 }, "i": { "x": 0.36, "y": 1 }, "s": [19.105, 8.8088], "t": 8 },
                  { "o": { "x": 0, "y": 0 }, "i": { "x": 0.36, "y": 1 }, "s": [19.105, 8.8088], "t": 10 },
                  { "o": { "x": 0.65, "y": 0 }, "i": { "x": 0.36, "y": 1 }, "s": [19.105, 16.8088], "t": 24 },
                  { "o": { "x": 0.65, "y": 0 }, "i": { "x": 0.36, "y": 1 }, "s": [19.105, 10.8088], "t": 36 },
                  { "o": { "x": 0.65, "y": 0 }, "i": { "x": 0.36, "y": 1 }, "s": [19.105, 13.8088], "t": 40 },
                  { "s": [19.105, 12.8088], "t": 46 }
                ]
              },
              "r": { "a": 0, "k": 0 },
              "sa": { "a": 0, "k": 0 },
              "o": { "a": 0, "k": 100 }
            }
          ]
        }
      ],
      "ind": 1
    }
  ],
  "v": "5.7.0",
  "fr": 30,
  "op": 51,
  "ip": 0,
  "assets": []
}
